/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 */
import DocumentsUploadPageWrapper from './DocumentsUploadPageWrapper';

export default DocumentsUploadPageWrapper;